// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1gZBB","consentsList":"PatientConsents_consentsList__2IySD","consentsListEmpty":"PatientConsents_consentsListEmpty__2BJV8"};